<template>
<e-chart
  ref="chart"
  @initialized="onChartReady"
  @destroy="onChartDestroy"
/>
</template>

<script>
import EChart from '../../../../components/Charts/ECharts'
import {AXIS_LABEL, AXIS_LINE_STYLE, TEXT_FONT_FAMILY} from '../../../../components/Data/FactorCharts/chartStyle'

const AQI_GRADES = [{
  value: 1,
  label: '优'
}, {
  value: 2,
  label: '良'
}, {
  value: 3,
  label: '轻度污染'
}, {
  value: 4,
  label: '中度污染'
}, {
  value: 5,
  label: '重度污染'
}, {
  value: 6,
  label: '严重污染'
}]

export default {
  name: 'AqiGrade',
  components: {EChart},
  methods: {
    render (dataList) {
      let chartOpt = {
        title: {
          text: 'AQI等级天数',
          left: 'center',
          textStyle: {
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {},
        legend: {
          top: 27,
          left: 'center',
          width: '75%',
          type: 'scroll'
        },
        grid: [{
          top: 75,
          right: 40,
          bottom: 45,
          left: 30,
          containLabel: true
        }],
        xAxis: [{
          type: 'category',
          data: AQI_GRADES.map(aqiGrade => aqiGrade.label),
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: TEXT_FONT_FAMILY
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          }
        }],
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
            // lineStyle: AXIS_LINE_STYLE
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        series: dataList.map(data => ({
          id: data.year,
          name: data.year,
          type: 'bar',
          barMaxWidth: 30,
          data: AQI_GRADES.map(({value}) => {
            let dataVal = data[value]
            return Number.isFinite(dataVal) ? dataVal : null
          }),
          label: {
            show: true,
            position: 'top'
          }
        }))
      }

      this.$refs.chart.setOpt(chartOpt)
    },
    onChartClick (param) {
      let year = Number(param.seriesId)
      let gradeName = param.name
      let gradeNum = AQI_GRADES.find(aqiGrade => aqiGrade.label === gradeName).value
      this.$emit('click', {
        year,
        grade: gradeNum
      })
    },
    onChartReady (chart) {
      chart.on('click', this.onChartClick)
    },
    onChartDestroy (chart) {
      chart.off('click', this.onChartClick)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/07VOCs-AQI/AqiGrade.vue